import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { supabase } from "./servicios/supabaseClient"; 
import { faFacebookF, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faHome, faShoppingCart, faSignInAlt, faUsers, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './App.css';
import imagenSobre from './imagen-sobre.jpg';
import imagen2 from './viniedo2.jpg';
import imagen1 from './viniedo1.jpg';
import './sobre-nosotros.css';
export default function SobreNosotros() {
  const vin1 = imagen1;
  const vin2 = imagen2;
  const logo2 = imagenSobre;
  const navigate = useNavigate();
  const [logueado, setLogueado] = useState(false);
  const [elementsVisible, setElementsVisible] = useState({});
  
  const historiaRef = useRef(null);
  const equipoRef = useRef(null);
  const miembrosRef = useRef([]);

  // ✅ Verificar sesión activa en Supabase
  useEffect(() => {
    const verificarSesion = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setLogueado(!!session);
    };

    verificarSesion();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setLogueado(!!session);
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  // ✅ Efecto para animaciones al hacer scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setElementsVisible(prev => ({
              ...prev,
              [entry.target.id]: true
            }));
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    // Observar elementos
    if (historiaRef.current) {
      historiaRef.current.id = 'historia';
      observer.observe(historiaRef.current);
    }
    if (equipoRef.current) {
      equipoRef.current.id = 'equipo';
      observer.observe(equipoRef.current);
    }

    miembrosRef.current.forEach((member, index) => {
      if (member) {
        member.id = `miembro-${index}`;
        observer.observe(member);
      }
    });

    return () => observer.disconnect();
  }, []);

  const addToMiembrosRef = (el, index) => {
    miembrosRef.current[index] = el;
  };

  return (
    <div className="sobre-nosotros-app">
      <header className="sobre-nosotros-header">
        <div className="header-content">
          <div className="logo-container">
            <div className='logan'>
              <h2>Almacen De Vinos</h2>
              <h3>El Sabor del Roble</h3>
            </div>
          </div>

          <div className="header-buttons">
            <button onClick={() => navigate("/")}>
              <FontAwesomeIcon icon={faHome} /> Inicio
            </button>

            {logueado ? (
              <>
                <button
                  onClick={async () => {
                    await supabase.auth.signOut();
                    setLogueado(false);
                    navigate("/");
                  }}
                >
                  <FontAwesomeIcon icon={faSignInAlt} /> Salir
                </button>
                <button onClick={() => navigate("/panel")}>
                  <FontAwesomeIcon icon={faUserShield} /> Panel
                </button>
              </>
            ) : (
              <button onClick={() => navigate("/login")}>
                <FontAwesomeIcon icon={faSignInAlt} /> Iniciar Sesión
              </button>
            )}
          </div>
        </div>
      </header>

      <main className="sobre-nosotros-main">
        <section 
          ref={historiaRef}
          className={`nuestra-historia scroll-reveal ${elementsVisible['historia'] ? 'revealed' : ''}`}
        >
          <div className="historia-content">
            <div className="historia-text scroll-reveal-left">
              <h2>Nuestra Historia</h2>
              <p>
                Almacén de Vinos – El Sabor del Roble, es una tienda online dedicada a la venta de vinos boutique y espumantes de alta gama, proveniente de bodegas del NOA y la región de Cuyo.
              </p>
              <p>
                Nuestro público son aquellas personas que desean descubrir vinos diferentes, exclusivos y a buen precio, sin la necesidad de acercarse a una vinoteca tradicional. Los productos que ofrecemos no se encuentran fácilmente en supermercados, lo que garantiza una experiencia única en el paladar de cada consumidor.
              </p>
            </div>
            <div className="historia-image scroll-reveal-right">
              <img src={logo2} alt="Nuestra Historia" className="historia-foto" />
            </div>
          </div>
        </section>

        <section 
          ref={equipoRef}
          className={`nuestro-equipo scroll-reveal ${elementsVisible['equipo'] ? 'revealed' : ''}`}
        >
          <h2>Nuestra Propuesta</h2>
          <div className="equipo-grid">
            <div 
              ref={(el) => addToMiembrosRef(el, 0)}
              className={`equipo-member stagger-item ${elementsVisible['miembro-0'] ? 'visible' : ''}`}
              style={{ transitionDelay: elementsVisible['equipo'] ? '0.1s' : '0s' }}
            >
              <div className="contenedor-imagen-viniedo">
                <img src={vin1} alt="Viñedo 1" className="equipo-foto" />
              </div>
              <p>
                A través de nuestra plataforma digital brindamos a nuestros clientes una compra práctica, segura y confiable, asegurando siempre un producto de la mas alta calidad. El principal propósito es facilitar la experiencia de compra, permitiendo acceder a vinos de excelencia en cualquier momento y desde la comodidad del hogar.
              </p>
            </div>

            <div 
              ref={(el) => addToMiembrosRef(el, 1)}
              className={`equipo-member stagger-item ${elementsVisible['miembro-1'] ? 'visible' : ''}`}
              style={{ transitionDelay: elementsVisible['equipo'] ? '0.3s' : '0s' }}
            >
              <div className="contenedor-imagen-viniedo">
                <img src={vin2} alt="Viñedo 2" className="equipo-foto" />
              </div>
              <p>
                Te invitamos a sumergirte en Almacén de Vinos - El Sabor del Roble, para descubrir las mejores cepas de vinos premium de las regiones vitivinicolas argentinas. Agradecemos y nos enorgullece tu visita. Elegí el vino para compartir tus momentos.
              </p>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo">
            <h3>El Sabor del Roble</h3>
            <p>Tradición y calidad en cada copa</p>
          </div>
          <div className="footer-links">
             <a 
    href="/sobre-nosotros" 
    onClick={(e) => {
      e.preventDefault();
      navigate('/sobre-nosotros');
    }}
  >
    Nosotros
  </a>
  
  {/* Catálogo - Va al inicio del Home */}
  <a 
    href="#" 
    onClick={(e) => {
      e.preventDefault();
      // Si estamos en otra página, navegamos al home
      if (window.location.pathname !== '/') {
        navigate('/');
        // Esperamos a que cargue el home y luego hacemos scroll
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 300);
      } else {
        // Si ya estamos en el home, solo scroll al top
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }}
  >
    Catálogo
  </a>
  
  {/* Contacto - Abre WhatsApp */}
  <a 
    href="#" 
    onClick={(e) => {
      e.preventDefault();
      const phoneNumber = "5493426126862"; // Tu número de WhatsApp
      const message = "Hola! Me interesa conocer más sobre sus productos";
      const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
      window.open(url, '_blank');
    }}
  >
    Contacto
  </a>
          </div>
          <div className="footer-social">
            <a  href="https://www.facebook.com/profile.php?id=100059121583485" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://www.instagram.com/vinosaboraroble?igsh=MzljY2xmZmRxaXBy" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://wa.me/5493426126862" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 El Sabor del Roble. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );

}
